import config from './config';

const USER_TOKENS_KEYS: string[] = [
  'ndp-oat',
  'ndp-ort',
];

function clearCookies(keysArr) {
  if (!keysArr || !keysArr.length) {
    return;
  }
  keysArr.forEach(
    key =>
      (document.cookie = `${key}=; domain=${config.COOKIES_DOMAIN}; path=/; secure; expires=Thu, 01 Jan 1970 00:00:00 GMT;`)
  );
}

export function clearUserCookies() {
  clearCookies(USER_TOKENS_KEYS);
}

export const getCookie = (key: string): string => {
  const name: string = key + '=';
  const decodedCookie: string = decodeURIComponent(document.cookie);
  const matchingTokensArr: string[] = decodedCookie
    .split(';')
    .map(cookie => cookie.trim())
    .filter(cookie => cookie.indexOf(name) === 0)
    .map(cookie => cookie.replace(name, ''));

  if (!matchingTokensArr || !matchingTokensArr.length) {
    return null;
  }

  return matchingTokensArr[0];
};

export const setCookie = (key: string, value: string) => {
  document.cookie = `${key} = ${value}; domain=${config.COOKIES_DOMAIN}; path=/; secure;`;
};

export function setCookiesAndRedirect(obj, redirectMiddleware?: (redirectUrl: string) => string) {
  Object.keys(obj).forEach(
    key => setCookie(key, obj[key])
  );

  const redirectUrl = window.location.origin;

  window.location.replace(redirectMiddleware ? redirectMiddleware(redirectUrl) : redirectUrl);
}